import { FLOODLIGHT_ID } from '../config';
import throttle from 'lodash.throttle';
let scrollPosition = 0;

export const disableScroll = () => {
  scrollPosition = window.pageYOffset;
  document.querySelector('html').setAttribute('style', 'overflow: hidden;'); // Prevents scroll bouncing
  document.body.setAttribute(
    'style',
    `
      position: fixed;
      width: 100%;
      top: -${scrollPosition}px;
    `
  );
};

export const enableScroll = () => {
  document.querySelector('html').removeAttribute('style');
  document.body.removeAttribute('style');
  window.scrollTo(0, scrollPosition);
};

export const storageItemExists = (item) => localStorage.getItem(item) !== null;
export const setStorageItem = (item, value) =>
  localStorage.setItem(item, value);

export const isPreRendering =
  window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.IS_PRERENDERING;

export const isKlickster = (domain) =>
  domain === 'klick.com' ||
  domain === 'katalystadvantage.com' ||
  domain === 'senseilabs.com';

export const addTrackingPixel = (src) => {
  const img = document.createElement('img');
  img.src = src;
  img.border = 0;
  img.height = 1;
  img.width = 1;
  img.style.visibility = 'hidden';
  img.style.height = '1px';
  img.style.width = '1px';
  img.style.position = 'absolute';
  img.style.bottom = 0;
  document.body.insertBefore(img, document.body.lastChild);
};

export const fireDCMTrackingEvent = (trackingCode) => {
  window.gtag('event', 'conversion', {
    allow_custom_scripts: true,
    send_to: `${FLOODLIGHT_ID}/Conv/${trackingCode}`,
  });
};

export const fireGATrackingEvent = (action, category, label, value) => {
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const getCookie = (cname) => {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

export const scrollTracker = () => {
  function inArray(array, element) {
    for (var i = 0; i < array.length; i++)
      if (array[i] === element) return true;
    return false;
  }

  function getDocumentHeight() {
    return Math.max(
      document.documentElement['scrollHeight'],
      document.body['scrollHeight'],
      document.documentElement['offsetHeight'],
      document.body['offsetHeight'],
      document.documentElement['clientHeight']
    );
  }

  function getPageYOffset() {
    return (
      window.pageYOffset ||
      (document.compatMode === 'CSS1Compat'
        ? document.documentElement.scrollTop
        : document.body.scrollTop)
    );
  }

  function getWindowHeight() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  }

  function calculateMarks(docHeight) {
    return {
      '25%': parseInt(docHeight * 0.25, 10),
      '50%': parseInt(docHeight * 0.5, 10),
      '75%': parseInt(docHeight * 0.75, 10),
      // Cushion to trigger 100% event in iOS
      '100%': docHeight - 5,
    };
  }

  function checkMarks(marks, scrollDistance) {
    // Check each active mark
    for (var key in marks) {
      if (!marks.hasOwnProperty(key)) continue;
      var val = marks[key];
      if (!inArray(cache, key) && scrollDistance >= val) {
        window.gtag('event', 'Percentage', {
          event_label: key,
          event_category: 'Scroll Depth',
          value: scrollDistance,
          non_interaction: true,
        });
        cache.push(key);
      }
    }
  }

  const cache = [];

  const trackScroll = (isInitial) => {
    const docHeight = getDocumentHeight(),
      winHeight = getWindowHeight(),
      scrollDistance = getPageYOffset() + winHeight,
      // Recalculate percentage marks
      marks = calculateMarks(docHeight);

    if (isInitial) {
      window.gtag('event', 'Percentage', {
        event_label: 'Baseline',
        event_category: 'Scroll Depth',
        value: scrollDistance,
        non_interaction: true,
      });
      return;
    }

    // If all marks already hit, unbind scroll event
    if (cache.length >= 4) {
      window.removeEventListener('scroll', trackScrollThrottled);
      return;
    }

    // console.log('marks :', marks);
    checkMarks(marks, scrollDistance);
  };

  const trackScrollThrottled = throttle(trackScroll.bind(this, false), 500);
  window.addEventListener('scroll', trackScrollThrottled);
  trackScroll(true);
};
